<h2 mat-dialog-title>{{ titulo }} <span class="total-count">({{ total }})</span></h2>

<mat-dialog-content>
  <div class="search-box mb-2">
    <i class="fas fa-search search-icon"></i>
    <input
      type="text"
      class="form-control form-control-sm search-input"
      placeholder="Buscar por nombre, localidad, dirección..."
      [(ngModel)]="busqueda"
      (ngModelChange)="onBusqueda()"
    />
  </div>

  <div class="d-flex justify-content-center py-4" *ngIf="isLoading">
    <div class="spinner-border text-brand" role="status"></div>
  </div>

  <div *ngIf="!isLoading">
    <div class="table-responsive" style="max-height: 380px; overflow-y: auto;">
      <table class="table table-hover table-sm mb-0">
        <thead class="sticky-top bg-light">
          <tr>
            <th>Nombre</th>
            <th>Localidad</th>
            <th>Provincia</th>
            <th>Gerenciadora</th>
            <th>Dirección</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of centros">
            <td class="font-weight-bold text-dark">{{ c.nombre }}</td>
            <td>{{ c.localidad }}</td>
            <td>{{ c.provincia }}</td>
            <td>{{ c.gerenciadora || '-' }}</td>
            <td class="small text-muted">{{ c.direccion || '-' }}</td>
          </tr>
          <tr *ngIf="!centros.length">
            <td colspan="5" class="text-center text-muted py-4">No hay centros para mostrar.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <button mat-button [disabled]="page === 0 || isLoading" (click)="paginaAnterior()">
        <i class="fas fa-chevron-left mr-1"></i> Anterior
      </button>
      <span class="small text-muted font-weight-bold">Página {{ page + 1 }} de {{ totalPaginas }} ({{ total }} centros)</span>
      <button mat-button [disabled]="page + 1 >= totalPaginas || isLoading" (click)="paginaSiguiente()">
        Siguiente <i class="fas fa-chevron-right ml-1"></i>
      </button>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="cerrar()">Cerrar</button>
</mat-dialog-actions>
